import React, { Component } from 'react';
import { showWhenPermission } from '@/shared/components/security';
import AssignmentAnalysisMatrix from '@/modules/hrm/assignmentAnalysis/AssignmentAnalysisMatrix';

class AssignmentAnalysisEmployeeCapacityReport extends Component {
  render() {
    return <AssignmentAnalysisMatrix matrixType="capacity"></AssignmentAnalysisMatrix>;
  }
}

export default showWhenPermission(
  'RegistrationOwn', // TODO:
  'read',
)(AssignmentAnalysisEmployeeCapacityReport);
